import React, { useState, useEffect } from 'react';
import { fetchRecentSearches, fetchMostSearched } from '../utils/api';
import './SearchHistory.css';

function SearchHistory({ currentUser, onApplySearch, isOpen, onClose }) {
  const [activeTab, setActiveTab] = useState('recent');
  const [recentSearches, setRecentSearches] = useState([]);
  const [mostSearched, setMostSearched] = useState([]);
  const [hoveredSearch, setHoveredSearch] = useState(null);

  useEffect(() => {
    if (isOpen && currentUser) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, currentUser]);

  const loadData = async () => {
    try {
      const recent = await fetchRecentSearches(currentUser.username);
      const most = await fetchMostSearched(currentUser.username);
      setRecentSearches(recent || []);
      setMostSearched(most || []);
    } catch (error) {
      console.error('Error loading search history:', error);
    }
  };

  if (!isOpen) return null;

  const handleSearchClick = (search) => {
    if (onApplySearch) {
      onApplySearch(search);
      onClose();
    }
  };

  return (
    <div className="search-history-overlay" onClick={onClose}>
      <div className="search-history-window" onClick={(e) => e.stopPropagation()}>
        <div className="search-history-header">
          <h3>Search History</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="search-tabs">
          <button 
            className={`tab-button ${activeTab === 'recent' ? 'active' : ''}`}
            onClick={() => setActiveTab('recent')}
          >
            Recent Searches
          </button>
          <button 
            className={`tab-button ${activeTab === 'most' ? 'active' : ''}`}
            onClick={() => setActiveTab('most')}
          >
            Most Searched
          </button>
        </div>

        <div className="search-content">
          {activeTab === 'recent' && (
            <div className="tab-content">
              {recentSearches.length === 0 ? (
                <p className="empty-message">No recent searches found</p>
              ) : (
                recentSearches.map((search, idx) => (
                  <div
                    key={search.id || idx}
                    className="search-item"
                    onMouseEnter={() => setHoveredSearch(search)}
                    onMouseLeave={() => setHoveredSearch(null)}
                    onClick={() => handleSearchClick(search)}
                  >
                    <div className="search-timestamp">
                      {new Date(search.timestamp).toLocaleString()}
                    </div>
                    <div className="search-results">
                      {search.results && search.results.slice(0, 3).map((food, i) => (
                        <div key={i} className={`search-result-item ${i === 0 ? 'first' : ''}`}>
                          {food['Food Item']}
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          {activeTab === 'most' && (
            <div className="tab-content">
              {mostSearched.length === 0 ? (
                <p className="empty-message">No search data found</p>
              ) : (
                mostSearched.map((food, idx) => (
                  <div
                    key={idx}
                    className="most-searched-item"
                    onMouseEnter={() => setHoveredSearch(food.latest_search)}
                    onMouseLeave={() => setHoveredSearch(null)}
                    onClick={() => food.latest_search && handleSearchClick(food.latest_search)}
                  >
                    <div className="food-name">{food.food_name}</div>
                    <div className="search-count">{food.count}</div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      {hoveredSearch && (
        <div className="preview-window" onClick={(e) => e.stopPropagation()}>
          <h4>Preview Search Settings</h4>
          <div className="preview-content">
            {['Spice', 'Sour', 'Sweet', 'Bitter', 'Umami', 'Salt', 'Fatty'].map(attr => (
              <div key={attr} className="preview-row">
                <label>{attr}: {hoveredSearch.preferences?.[attr]}</label>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={hoveredSearch.preferences?.[attr] || 5}
                  disabled
                />
              </div>
            ))}
            <div className="preview-info">
              <p><strong>Temperature:</strong> {hoveredSearch.preferences?.hot_cold || 'Both'}</p>
              {hoveredSearch.exclusions && Object.entries(hoveredSearch.exclusions)
                .filter(([key, value]) => value)
                .length > 0 && (
                <p><strong>Excluded:</strong> {
                  Object.entries(hoveredSearch.exclusions)
                    .filter(([key, value]) => value)
                    .map(([key]) => key.replace('exclude', ''))
                    .join(', ')
                }</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchHistory;

